import React, { useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row, Spinner, Label, FormGroup, Input } from 'reactstrap';
import { useCreateOrUpdateAnalytes } from '../../../hooks/exams/useCreateOrUpdateAnalytes';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalAnalytes } from '../../../components/analytes/ModalAnalytes';
import { FormAnalytes } from '../../../components/analytes/FormAnalytes';
import { ModalTestFormula } from '../../../components/analytes/ModalTestFormula';
import { ModalRange } from '../../../components/analytes/ModalRange';
import { ModalOrderAnalytes } from '../../../components/analytes/ModalOrderAnalytes';
import { Modal } from 'react-morphing-modal';
import { ModalComplex } from '../../../components/analytes/ModalComplex';
import 'react-morphing-modal/dist/ReactMorphingModal.css';
import { ModalOrderPrintAnalytes } from '../../../components/analytes/FormsTypeAnalytes/ModalOrderPrintAnalytes';
import Breadcrumb from '../../../layout//breadcrumb'
import { useDetectedActivity } from '../../../hooks/exams/useDetectedActivity';
import './StyleExam.css';
import { useHistory } from 'react-router-dom';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import { GlobalReferenceValue } from './GlobalReferenceValue';
import { ModalCurveAnalytes } from '../../../components/analytes/ModalCurveAnalytes';
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSweetAlert } from '../../../hooks/sweetAlerts/useSweetAlert';
import { InputText } from 'primereact/inputtext';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';

export const CreateOrUpdateAnalytes = () => {
    const {
        analytes, loadingAnalytes, exam, analytesGroup, analytesGroupPrint, groupAnalytes, typeAnalytes, typePrecodedTexts, units, unitsTo,
        isOpen, toggle, loading, modal, toggleModal, nameAnalyte, loadingModal,
        handleInputChange, validaciones, methodActive, validateFormula,
        name, app_code, code, id_analyte_group, name_analyte_group, id_type_analyte, id_info_analyte, print, required, id_type_precoded_text, integers, decimals, id_unit, id_unit_to, compute, check_compute, replace, id_exam, loinc_num,
        addAnalyte, removeAnalyte, saveAnalytes, deleteAnalyte, handleEdit, editAnalyte, backCreate, changeUnit, validarFormula, resetValidarFormula,
        toggleTest, modalTest, loadingTest, testearFormula,
        init_range, end_range, value, increment, handleInputTest, resetTest, results, resetResults, handleModalTest,
        handleFullModal, modalProps, modalFullRef,
        gender, init_value, end_value, years_from, months_from, days_from, years_to, months_to, days_to, text_range, validacionesRange, method, methods,
        handleInputRange, resetRange, precodedTexts, listRanges, addAnalyteNumberRange, removeAnalyteNumberRange, saveTempAnalytesNumberRanges, editAnalyteNumberRange,
        id_analyte_age_gender_range, handleInputRangePrecoded,
        listRangesPrecoded, addRangePrecoded, saveTempRangePrecoded, removeRangePrecoded, editRangePrecoded, saveEditRangePrecoded, methodActiveRangePrecoded, backToCreateRangePrecoded,
        saveEditAnalyteRangeNumber, methodActiveRange, backToCreateRange, loincState,
        handleModalOrder, modalOrder, loadingOrder, saveOrderAnalytes,
        handleModalOrderPrint, modalOrderPrint, loadingOrderPrint, saveOrderPrintAnalytes,
        activeModal, analytesAvailables, refreshFormComplex, responseComplexText, refreshResultComplex, preSavedFormComplex, analytesComplex, exams,
        saveTempAnalytesNumberAlerts, listReferenceValues,
        handleValueBold, handleValueItalics, handleValueUnderline, handleValueFormatTransform, valueBold, valueItalics, valueUnderline, valueFormatTransform,
        selectedInfoAnalytes, infoAnalytes, handleValueInfoAnalyte,
        selectedInfoCharacteristics, infoCharacteristics, handleValueInfoCharacteristics,
        selectedExamSimple, simpleExams, handleValueExamSimple,
        selectedAnalyteImport, analytesFromExam,
        saveTempAnalytesTextAlerts, listReferenceTexts,
        tabTypeAnalyte, toggleTypeAnalyte,
        options, onChange, data, handleChangeTextP, prueba, selected, savePrecodText,
        // global reference        
        viewGlobalReferenceValue, handleViewGlobalReference,

        //curves
        handleConfigurationCurves,formCurves,unitCurves,handleInputChangeCurve,
        colorCurve,handleGenerateTakes,handleChangeTime,handleDelete,handleEditorChange,enabledFields,handleUnlockRow,dataMethodCurve,
        getAvailableTimes,saveSendCurves,
        saveSendInfoAnalyteRanges,visible,setVisible,

        handleResetComplexAnalyte, analyteId, setFormCurves, mainRows, selectedTimes, setMainRows, setSelectedTimes, timeCurves, handleChangeTimeCurves,
        getAvailableTimeOptions, genderOptions, handleChangeGender, expandedRows, setExpandedRows, handleSelectValues, handleChangeAgeField, handleRemoveSubRow,
        handleAddSubRow, loadingSaveCurve, hasMethod,
        handleSearchAnalytes, searchAnalytes, filteredAnalytes,
        openDeleteAlert, closeDeleteAlert, modalAlert, showDeleteAlert, print_graph, showCustomAlertConfirm ,customAlert


    } = useCreateOrUpdateAnalytes(false, true);
    // ////console.log(infoAnalytes, "---");
    const { innerHeight: height } = window;
    const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett, sweetConfirmationUpdate, sweetConfirmRepeatExam, sweetConfirmationChangeClient, sweetConfirmationCancel, sweetValidDate,sweetDeleteBacterium1,sweetDoctorDelete, sweetAgreements, sweetAgreementMode, sweetConfirmationCsv, sweetDeleteGlobal,sweetAcceptGlobal] = useSweetAlert()

    const txtsection = localStorage.getItem('TextAS');
    const history = useHistory();

    useDetectedActivity(60000, 10000);



    // #region CURVES
    const [expandedRowsAnalytes, setExpandedRowsAnalytes] = useState({});


   const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center gap-2">
                <Button
                    outline
                    color="danger"
                    size="sm"
                    onClick={async () => {
                        const isConfirmed = await sweetDeleteGlobal(
                            "Eliminar",
                            "¿Estás seguro de eliminar esta toma?",
                            "warning",
                            true
                        );

                        if (isConfirmed) {
                            handleDelete(rowData.id); 
                        }
                    }}
                    disabled={formCurves.isEdit ? true :  false}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };


    const actionsAnalytes = (rowData) => {
        const isExpanded = expandedRowsAnalytes[rowData.id_analyte];

       
        const toggleRow = () => {
            setExpandedRowsAnalytes(prev => {
                const expanded = { ...prev };

                if (expanded[rowData.id_analyte]) {
                    delete expanded[rowData.id_analyte];
                } else {
                    expanded[rowData.id_analyte] = true;
                }

                return expanded;
            });
        };


        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "4px" }}>
                <Button
                    // color="info"
                    size="sm"
                    onClick={toggleRow}
                    style={{ padding: "2px", height: "26px", width: "26px", backgroundColor: "#566a87" }}
                >
                    <i className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`} />
                </Button>

                <Button color="primary" size="sm"  style={{ padding: "2px", height: "26px", width: "26px"}} onClick={() => handleEdit(rowData.id_analyte)}>
                    <i className="fa fa-edit" />
                </Button>

                <Button color="danger" size="sm" style={{ padding: "2px", height: "26px", width: "26px"}} onClick={() => removeAnalyte(rowData.id_analyte)}>
                    <i className="fa fa-trash" />
                </Button>
            </div>
        );
    };



    const rowExpansionTemplate = (data) => {
        return (
            <div className="table-responsive">
                <DataTable
                    value={[data]}
                    className="data-table p-datatable-striped p-datatable-sm"
                    emptyMessage={
                        <div className="text-center">
                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                Sin Información.
                            </p>
                        </div>
                    }
                    responsiveLayout="scroll"
                >
                    <Column
                        header="Tipo de captura"
                        headerStyle={headerStyleAnalytes}
                        style={centerStyleAnalytes}
                        body={(rowData) => (
                            rowData.required ? "Riguroso" : "No riguroso"
                        )}
                    />
                    <Column
                        header="Impresión"
                        headerStyle={headerStyleAnalytes}
                        style={centerStyleAnalytes}
                        body={(rowData) => (
                            rowData.print ? "Sí" : "No"
                        )}
                    />
                    <Column  header="Grupo de analitos" headerStyle={headerStyleAnalytes} style={centerStyleAnalytes} 
                        body={(rowData) =>
                            rowData.name_analyte_group !== null &&
                            rowData.name_analyte_group !== undefined &&
                            rowData.name_analyte_group !== ""
                                ? rowData.name_analyte_group
                                : "---"
                        }/>
                    <Column field="integers" header="Número de dígitos" headerStyle={headerStyleAnalytes} style={centerStyleAnalytes} 
                        body={(rowData) =>
                            rowData.integers !== null &&
                            rowData.integers !== undefined &&
                            rowData.integers !== ""
                                ? rowData.integers
                                : "---"
                        }/>
                    <Column header="Número de decimales" headerStyle={headerStyleAnalytes} style={centerStyleAnalytes}
                        body={(rowData) =>
                            rowData.decimals !== null &&
                            rowData.decimals !== undefined &&
                            rowData.decimals !== ""
                                ? rowData.decimals
                                : "---"
                        }
                    />
                    <Column header="Unidad" headerStyle={headerStyleAnalytes} style={centerStyleAnalytes} 
                        body={(rowData) =>
                            rowData.name_unit !== null &&
                            rowData.name_unit !== undefined &&
                            rowData.name_unit !== ""
                                ? rowData.name_unit
                                : "---"
                        }/>
                </DataTable>
            </div>
        );
    };


   const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const headerStyleAnalytes = {
        backgroundColor: "#1593c1",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyleAnalytes = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };
    const centerStyleAnalytes = {
    ...cellStyleAnalytes,
    textAlign: "center",
};

   

    // #endregion


    return (
        <div>

            <div> 
                {
                    exam.is_curve &&   <Col sm="12" className='p-l-0 p-r-0' >
                        <Card className="shadow container-global-zoom">
                            <CardHeader className="p-1 mt-3 ">
                                <div className="d-flex flex-column">
                                     <div className="d-flex justify-content-between align-items-center">
                                        <span className="labelTypeAnalyte">
                                            Exámen: <span className="txt-primary">{exam.name}</span>
                                        </span>
                                        <span className="labelTypeAnalyte">
                                            {txtsection} : <span className="txt-primary">{exam.name_section}</span>
                                        </span>
                                    </div>
                                    <br />
                                    <div className="d-flex justify-content-center">
                                        <Button color="light" className="mr-1 ml-1" size="xs" onClick={() => history.goBack()}>
                                            <i className="icofont icofont-arrow-left"></i> {"Regresar"}
                                        </Button>
                                        <Button onClick={handleModalOrderPrint} outline color="primary" className="mr-1 ml-1" size="xs" type="button">
                                            <i className="fa fa-print"></i>
                                            <label className="labelConfigurationPrint">Ordenar impresión</label>
                                        </Button>
                                        <Button onClick={handleModalOrder} outline color="primary" className="mr-1 ml-1" size="xs" type="button">
                                            <i className="fa fa-sort"></i>
                                            <label className="labelConfigurationPrint">Ordenar analitos</label>
                                        </Button>
                                        <Button onClick={handleViewGlobalReference} outline={viewGlobalReferenceValue ? false : true} color="primary" className="mr-1 ml-1" size="xs" type="button">
                                            <label className="labelConfigurationPrint">
                                            {viewGlobalReferenceValue ? 'Listado de analitos' : 'Valor de referencia global'}
                                            </label>
                                        </Button>
                                    </div>
                                   
                                </div>
                            </CardHeader>
                                {
                                    // ? Curvas
                                }
                                {
                                exam.is_curve &&  
                                    <Col sm="12">
                                        <Row className='mt-2'>
                                            <Col xs="12" className="text-left mt-2">
                                                        <Label  style={{ fontWeight: 'bold', fontSize: '14px' }}>Curvas</Label>
                                            </Col>
                                            <Col sm="3" className="text-left"> 
                                                        <FormGroup>
                                                            <Label className="text-sm">Analitos<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                                <Select
                                                                    name="id_info_analyte"
                                                                    isClearable={true}
                                                                    placeholder="Selecciona un Analito"
                                                                    isDisabled={formCurves.isEdit ? true : false}
                                                                    options={infoAnalytes}
                                                                    value={formCurves.id_info_analyte}
                                                                    onChange={(e) => handleConfigurationCurves(e, "id_info_analyte")}
                                                                    menuPortalTarget={document.body}
                                                                    styles={colorCurve}
                                                                    
                                                                />
                                                        </FormGroup>
                                            </Col>
                                            <Col sm="2">
                                                        <Label className="text-sm">Número de tomas<span className='f-16' style={{ color: "#0079C7" }}>*</span> </Label>
                                                    <Input
                                                        type="number"
                                                        value={formCurves.takes}
                                                        onChange={(e) => handleInputChangeCurve(e, "takes")}
                                                        style={{ height: '38px'}}
                                                        className='form-control form-control-sm input-air-primary border-primary'
                                                        disabled={formCurves.isEdit ? true : false}

                                                    />
                                            </Col>
                                            <Col sm="2">
                                                    <Label className="text-sm">Número de decimales<span className='f-16' style={{ color: "#0079C7" }}>*</span> </Label>
                                                    <Input
                                                        type="number"
                                                        value={formCurves.num_decimals}
                                                        onChange={(e) => handleInputChangeCurve(e, "num_decimals")}
                                                        className='form-control form-control-sm input-air-primary border-primary'
                                                        style={{ height: '38px'}}
                                                    />
                                            </Col>
                                            <Col sm="3" className="text-left"> 
                                                <FormGroup>
                                                    <Label className="text-sm">Unidad(opcional)</Label>
                                                        <Select
                                                            name="id_unit"
                                                            isClearable={true}
                                                            placeholder="Selecciona una unidad"
                                                            options={unitCurves}
                                                            value={formCurves.id_unit}
                                                            onChange={(e) => handleConfigurationCurves(e,"id_unit")}
                                                            menuPortalTarget={document.body}
                                                            styles={colorCurve}
                                                        />

                                                </FormGroup>
                                            </Col>
                                            <Col sm="1" className={formCurves.isEdit ? "d-none" : "mt-3 p-l-0 " } >
                                                <Button
                                                    color="primary"
                                                    size="sm"  
                                                    className="mt-2 p-1"
                                                    onClick={() => {
                                                        const numero = parseInt(formCurves.takes);  

                                                        if (!formCurves.id_info_analyte || !formCurves.id_info_analyte.value) {
                                                            createSweett("Curva", "No se ha seleccionado el campo del analito.", "error");  
                                                            return;  
                                                        }

                                                        if (isNaN(numero) || numero <= 0) {
                                                            createSweett("Curva", "No se ha seleccionado un numero de toma.", "error");  
                                                            return;  
                                                        }
                                                        
                                                        if (numero < 1 || numero > 10) {
                                                            createSweett("Curva", "El número de tomas debe estar entre 1 y 10.", "error");  
                                                            return;  
                                                        }

                                                        if (formCurves.decimals === null || formCurves.decimals <= 0) {
                                                            createSweett("Curva", "Por favor, ingresa el número de decimales válido.", "error");  
                                                            return;  
                                                        }

                                                        handleGenerateTakes(formCurves.id_info_analyte, numero, formCurves.id_info_analyte.label);  
                                                    }}
                                                    title="Generar Tomas"
                                                >
                                                    <i className="fa fa-table fa-2x"></i> 
                                                </Button>
                                            </Col>
                                            <Col sm="12" >
                                                <div className="table-responsive">
                                                    <DataTable
                                       value={formCurves.arrayCurves}

                                                        lazy className="data-table p-datatable-striped p-datatable-sm" 
                                                        responsiveLayout="scroll"
                                                        emptyMessage={
                                                            <div className="text-center">
                                                                <p className='badge badge-light-primary mt-2' style={{fontSize: "13px"}}>
                                                                    Sin Información Ingresada.
                                                                </p>
                                                            </div>
                                                            }>
                                                        <Column 
                                                            field="toma" 
                                                            header="Toma"
                                                            headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize:"12px", width: '45%' }}
                                                            style={{ fontSize: "12px", padding: "5px", width: '45%' }}
                                                        />
                                                        <Column 
                                                            field="tiempo" 
                                                            header="Tiempo"
                                                            headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", width: '45%' }}
                                                            style={{ fontSize: "12px", textAlign: 'center', width: '45%' }}
                                                            body={(rowData, options) => (
                                                                <Select
                                                                    name="curves"
                                                                    isClearable={true}
                                                                    placeholder="Selecciona un tiempo"
                                                                    options={getAvailableTimes(options.rowIndex)}
                                                                    onChange={(selectedOption) => handleChangeTime(options.rowIndex, selectedOption)}
                                                                    value={rowData.tiempo}
                                                                    getOptionLabel={e => e.label}
                                                                    getOptionValue={e => e.value}
                                                                    styles={{
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                        control: base => ({ ...base, fontSize: '12px' }),
                                                                        option: base => ({ ...base, fontSize: '12px' }),
                                                                        }}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                                )}
                                                        />
                                                        <Column
                                                            header="Acción"
                                                            body={actions}
                                                            exportable={false}
                                                            headerStyle={{ backgroundColor: "#0d3b59", color: "#fff", fontWeight: "bold", fontSize: "12px", width: '10%' }}
                                                            style={{ fontSize: "12px", textAlign: 'center', width: '10%' }}
                                                        />
                                                    </DataTable>
                                                </div>
                                            </Col>
                                            <Col sm="12" className='pt-2' >
                                                <Row className="align-items-center mt-2">
                                                    <Col xs="12" className="d-flex justify-content-end">
                                                        <Button
                                                            color="info"
                                                            size="sm"
                                                            className="mr-2"
                                                            onClick={async () => {
                                                                if (!formCurves.isEdit) {
                                                                const isConfirmed = await sweetAcceptGlobal(
                                                                    "¿Estás seguro de guardar la configuración de la curva?",
                                                                    "Una vez guardado, no podrás modificar ni el analito ni el número de tomas.",
                                                                    "warning",
                                                                    true
                                                                );

                                                                if (isConfirmed) {
                                                                    await saveSendCurves();
                                                                }
                                                                } else {
                                                                await saveSendCurves(); 
                                                                }
                                                            }}
                                                            >
                                                            <i className="fa fa-save mr-1"></i> Guardar Curva
                                                        </Button>
                                                        <Button className={formCurves.isEdit ? "" : "d-none"}  color="success" size="sm" onClick={() => setVisible(true)} >
                                                            <i className="fa fa-info-circle mr -1"></i> Valores de referencia curva
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <br /><br />
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                                           
                        </Card>
                
                </Col>
                }
            
                        {/* style={{ height: height - 300, overflow: "scroll", top: 150  datos mostrados de la misma linea de trabajo en la conexion  }} */}
                <Row>
                    <Col className='analyte-col container-global-zoom pl-4' id="accordionoc" xs="12" sm="8" md="8" lg="4" xl="4"  >
                        <div className="sticky-analyte-header">                            
                            <Card className="shadow">

                       
                                <CardHeader className="integration-card-header p-3">
                                    {
                                        methodActive === "create" ?
                                            <label className='labelIntegracionAnalyte'>Integración de analitos </label> :
                                            (
                                                <>
                                                    <Row>
                                                        <Col sm="5"> 
                                                            <h7>Edición de analito</h7>
                                                        </Col>

                                                         <Col sm="7">
                                                            <i className="fa fa-long-arrow-left"></i><h7 style={{ cursor: "pointer" }} onClick={backCreate}>&nbsp;  Regresar a creación</h7> <br />

                                                        </Col>
                                                    </Row>
                                                </>
                                            )
                                    }
                                </CardHeader>
                                <div className="analyte-scroll">
                                <FormAnalytes
                                    {...{
                                        methodActive, addAnalyte, editAnalyte, changeUnit, validarFormula, resetValidarFormula,
                                        name, app_code, code, id_analyte_group, name_analyte_group, id_type_analyte, id_info_analyte, print, required, id_type_precoded_text, integers, decimals, id_unit, id_unit_to, compute, replace, check_compute, id_exam, loinc_num,
                                        groupAnalytes, typeAnalytes, typePrecodedTexts, units, unitsTo,
                                        handleInputChange, validaciones, validateFormula, handleModalTest,
                                        handleFullModal, modalFullRef, loincState,
                                        handleValueBold, handleValueItalics, handleValueUnderline, handleValueFormatTransform, valueBold, valueItalics, valueUnderline, valueFormatTransform,
                                        selectedInfoAnalytes, infoAnalytes, handleValueInfoAnalyte,
                                        selectedInfoCharacteristics, infoCharacteristics, handleValueInfoCharacteristics,
                                        selectedExamSimple, simpleExams, handleValueExamSimple,
                                        selectedAnalyteImport, analytesFromExam,
                                        tabTypeAnalyte, toggleTypeAnalyte, handleChangeTextP, handleResetComplexAnalyte, analyteId, print_graph
                                    }}
                                />
                                </div>
                            </Card>


                        </div>
                    </Col>

                    <Col sm="8" className='container-global-zoom pr-4'>      
                        {
                            (id_type_analyte === "1" && id_type_precoded_text >= 1) ?
                                <div>
                                    <CardHeader className="analyte-exam-head">
                                        <div className="analyte-exam-head-content">
                                            <div className="analyte-exam-info">
                                                <span className="analyte-exam-label">Examen</span>
                                                <h3 className="analyte-exam-name">{exam.name}</h3>
                                            </div>
                                            <div className="analyte-exam-section">
                                                <span>{txtsection}</span>
                                                <strong>{exam.name_section}</strong>
                                            </div>
                                        </div>
                                    </CardHeader>

                                    <div className="precode-box-header">
                                        <div className="precode-box-title-wrap">
                                            <div className="precode-box-icon">
                                                <i className="fa fa-list-ul"></i>
                                            </div>

                                            <div className="precode-box-title-copy">
                                                <span className="precode-box-label">
                                                    Textos precodificados
                                                </span>

                                                <p>
                                                    Agrega o elimina los textos que deseas utilizar.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="precode-box-badge">
                                            <strong>{selected?.length || 0}</strong>
                                            <span>seleccionados</span>
                                        </div>
                                    </div>
                            
                                    <Col sm="12">
                                        <Row>
                                            <Col sm="12">
                                                <DualListBox
                                                    selected={selected}//el que va a la derecha
                                                    simpleValue={false}
                                                    onChange={onChange}
                                                    filterPlaceholder={"Buscar..."}
                                                    showNoOptionsText={true}
                                                    canFilter options={data}//izquierda
                                                    lang={{
                                                        moveAllLeft: 'Remover todas las opciones',
                                                        moveAllRight: 'Agregar todas las opciones',
                                                        moveLeft: 'Remover la opción seleccionada',
                                                        moveRight: 'Agregar la opcion seleccionada',
                                                        moveBottom: 'Move to bottom',
                                                        noAvailableOptions: 'No hay más textos precodificados disponibles',
                                                        noSelectedOptions: 'No se ha seleccionado ningún texto precodificado',
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <br />
                                            
                                </div>
                                :
                                <div>

                                
                                <Card className={`shadow-sm border height-equal pricingtable rounded-3 p-3 mb-4 ${exam.is_curve ? "d-none" : ""}`}>
                                    <div className="d-flex flex-column">
                                        <div
                                        className="d-flex justify-content-between align-items-center mt-1"
                                        style={{ width: "100%", borderBottom: "1px solid #76c1e7ff", paddingBottom: "1px" }}
                                        >
                                        <div className="d-flex align-items-center">
                                            <i className="mr-2 text-primary" style={{ fontSize: "18px" }}></i>
                                            <span className="labelTypeAnalyte">
                                            Exámen: <span className="font-weight-bold">{exam.name}</span>
                                            </span>
                                        </div>

                                        <div className="d-flex align-items-center">
                                            <i className="mr-2 text-primary" style={{ fontSize: "18px" }}></i>
                                            <span className="labelTypeAnalyte">
                                            {txtsection}: <span className="font-weight-bold">{exam.name_section}</span>
                                            </span>
                                        </div>
                                        </div>
                                        <br />



                                        <div className="d-flex justify-content-center">
                                            <Button 
                                                color="secondary" 
                                                size="sm" 
                                                onClick={() => history.goBack()}
                                            >
                                                <i className="icofont icofont-arrow-left mr-1"></i> Regresar
                                            </Button>

                                            <Button 
                                                outline 
                                                color="primary" 
                                                size="sm" 
                                                onClick={handleModalOrderPrint}
                                            >
                                                <i className="fa fa-print mr-1"></i>
                                                Ordenar impresión
                                            </Button>

                                            <Button 
                                                outline 
                                                color="primary" 
                                                size="sm" 
                                                onClick={handleModalOrder}
                                            >
                                                <i className="fa fa-sort mr-1"></i>
                                                Ordenar analitos
                                            </Button>

                                            <Button 
                                                color="primary" 
                                                outline={!viewGlobalReferenceValue} 
                                                size="sm" 
                                                onClick={handleViewGlobalReference}
                                            >
                                                {viewGlobalReferenceValue ? 'Listado de analitos' : 'Valor de referencia global'}
                                            </Button>
                                        </div>
                                    </div>
                                </Card>

                                    {
                                            // ? END CURVES
                                    }
                                    
                                    {
                                        <Card className='shadow-sm border height-equal pricingtable rounded-3 p-3 mb-4 '>
                                            {
                                                viewGlobalReferenceValue ?
                                                    <GlobalReferenceValue examId={id_exam}
                                                    />
                                                    :

                                                    loadingAnalytes ?
                                                        <>
                                                            Cargando... &nbsp;<Spinner size="sm" />
                                                        </>
                                                        :
                                                        analytes.length > 0 ?
                                                            <Row>
                                                               <div className="d-flex align-items-center mb-3" style={{ position: "relative", width: "100%" }}>
                                                                    <div
                                                                        className="ribbon ribbon-clip ribbon-primary"
                                                                        style={{ position: "static", flexShrink: 0 }}
                                                                    >
                                                                        Listado de Analitos
                                                                    </div>

                                                                    <div style={{ flex: 1 }} />

                                                                   <span className="p-input-icon-left" style={{ width: "230px" }}>
                                                                        {/* <i className="pi pi-search" /> */}
                                                                        <InputText
                                                                            type="search"
                                                                            value={searchAnalytes}
                                                                            onChange={(e) => handleSearchAnalytes(e.target.value)}
                                                                            placeholder="Búsqueda..."
                                                                            style={{ width: "100%" }}
                                                                        />
                                                                    </span>

                                                                </div>

                                                                <div className="table-responsive ">
                                                                    <DataTable 
                                                                        value={filteredAnalytes}
                                                                        expandedRows={expandedRowsAnalytes}
                                                                        onRowToggle={(e) => setExpandedRowsAnalytes(e.data)}
                                                                        rowExpansionTemplate={rowExpansionTemplate}
                                                                        className="data-table p-datatable-striped p-datatable-sm"
                                                                        dataKey="id_analyte"
                                                                        emptyMessage={
                                                                            <div className="text-center">
                                                                                <img
                                                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                                    style={{ width: "40%" }}
                                                                                    alt="Sin Cotizaciones"
                                                                                />
                                                                                <br />
                                                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                                                    Sin Analitos.
                                                                                </p>
                                                                            </div>
                                                                        }
                                                                        responsiveLayout="scroll"
                                                                        >
                                        
                                                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                                                        <Column header="¿Es Analito?"body={(rowData) => ( rowData.is_analyte ? "Sí" : "No" )}  headerStyle={headerStyle} style={centerStyle} />
                                                                        <Column field="name" header="Analito"  headerStyle={headerStyle} style={centerStyle} />
                                                                        <Column field="code" header="Código"  headerStyle={headerStyle} style={centerStyle} />
                                                                        <Column field="name_type_analyte" header="Tipo"  headerStyle={headerStyle} style={centerStyle} />
                                                                        <Column header="Acciones" body={actionsAnalytes}exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                                                    </DataTable>
                                                                </div>


                                                                <Button
                                                                    type="button"
                                                                    color="info"
                                                                    className={"btn-block mt-2" + (loading ? "disabled progress-bar-animated progress-bar-striped" : "")}
                                                                    onClick={saveAnalytes}
                                                                >
                                                                    Guardar analitos
                                                                </Button>
                                                                <Col className='mt-4'>
                                                                <br />
                                                                </Col>
                                                            </Row>
                                                            
                                                            :
                                                            <>
                                                                <div style={{ textAlign: "-webkit-center" }}>
                                                                    <img className="img-fluid" src={require("../../../assets/images/loginHelenLabs/Alerts/Alert.svg")} style={{ width: "35%" }} alt="" />   <br />
                                                                    <br /> <p className="f-18">{"0 Análitos agregados."}</p>
                                                                </div>
                                                            </>
                                            }
                                    </Card>
                                    }
                                </div>
                        }
                        {/* </Card> */}
                    </Col>


                </Row>
                {showDeleteAlert && (
                    <AlertDataTable
                        titleAlert="Eliminar Analito"
                        visibleAlert={modalAlert}
                        onHideAlert={closeDeleteAlert}
                        sizeAlert="medium-dialog delete-method"
                        messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el analito del examen?"
                        alert1={true}
                        titleAlert1={nameAnalyte}
                        buttonAcept
                        titleNotLoading="Eliminar"
                        titleDanger="Cancelar"
                        actionAcept={deleteAnalyte}
                        
                    />

                )}

                    
                
                {/* <ModalAnalytes
                    {...{ modal, toggleModal, nameAnalyte, loadingModal, deleteAnalyte }}
                /> */}
                <ModalTestFormula
                    {...{
                        toggleTest, modalTest, loadingTest, testearFormula, compute,
                        init_range, end_range, value, increment, handleInputTest, resetTest, results, resetResults
                    }}
                />
                <Modal {...modalProps} padding={false} className="containerZ"  >
                    {
                        // TODO:estoy armando el modal para los puros rangos, estoy pasando la variable de "method" y debo continuar con es Daniel del futuro, no te estreses.
                        activeModal === "modalRangos" ?
                            (<ModalRange
                                {...{
                                    name, gender, init_value, end_value, years_from, months_from, days_from, years_to, months_to, days_to, text_range,
                                    handleInputRange, resetRange, validacionesRange, method, methods, id_type_analyte,
                                    id_type_precoded_text, precodedTexts, listRanges, addAnalyteNumberRange, removeAnalyteNumberRange, saveTempAnalytesNumberRanges, editAnalyteNumberRange,
                                    saveEditAnalyteRangeNumber, methodActiveRange, backToCreateRange,
                                    id_analyte_age_gender_range, handleInputRangePrecoded,
                                    listRangesPrecoded, addRangePrecoded, saveTempRangePrecoded, removeRangePrecoded, editRangePrecoded, saveEditRangePrecoded, methodActiveRangePrecoded, backToCreateRangePrecoded,
                                    saveTempAnalytesNumberAlerts, listReferenceValues,
                                    saveTempAnalytesTextAlerts, listReferenceTexts,
                                    tabTypeAnalyte, toggleTypeAnalyte, hasMethod, showCustomAlertConfirm ,customAlert
                                }}
                            />)
                            :
                            <ModalComplex
                                {...{
                                    analytesAvailables, refreshFormComplex, responseComplexText, refreshResultComplex, preSavedFormComplex, analytesComplex, exams, exam, methodActive, name
                                }}
                            />
                    }
                </Modal>
                {
                    modalOrder &&

                    <ModalOrderAnalytes
                        {...{
                            analytesGroup, modalOrder, loadingOrder, handleModalOrder, saveOrderAnalytes
                        }}
                    />
                }
                {
                    modalOrderPrint &&

                    <ModalOrderPrintAnalytes
                        {...{
                            analytesGroupPrint, modalOrderPrint, loadingOrderPrint, handleModalOrderPrint, saveOrderPrintAnalytes
                        }}
                    />
                }

                <ModalCurveAnalytes
                    {...{
                        visible, setVisible,formCurves,handleEditorChange,enabledFields,handleUnlockRow,dataMethodCurve,saveSendInfoAnalyteRanges,handleConfigurationCurves,
                        getAvailableTimes, handleChangeTime, setFormCurves, mainRows, selectedTimes,  setMainRows, setSelectedTimes, 
                        
                        timeCurves, handleChangeTimeCurves, getAvailableTimeOptions, genderOptions, handleChangeGender, expandedRows, setExpandedRows, handleSelectValues, handleChangeAgeField,
                        handleRemoveSubRow, handleAddSubRow, loadingSaveCurve

                    }

                    }
                />
            </div>
        </div >
    )
}